import { render, staticRenderFns } from "./Translations.vue?vue&type=template&id=9709bb46&scoped=true"
import script from "./Translations.vue?vue&type=script&lang=ts"
export * from "./Translations.vue?vue&type=script&lang=ts"
import style0 from "./Translations.vue?vue&type=style&index=0&id=9709bb46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9709bb46",
  null
  
)

export default component.exports